import { render, staticRenderFns } from "./HwadzanGardenIntro.vue?vue&type=template&id=100abad4&"
import script from "./HwadzanGardenIntro.vue?vue&type=script&lang=js&"
export * from "./HwadzanGardenIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports